import React, {FC, useEffect, useState} from 'react';
import {classNames} from 'classnames-generics';
import {useTranslation} from 'react-i18next';
import styles from './styles.module.scss';
import "./../../locales/langs";
import UserProfile from './../../components/UserProfile';
import ProfileIcons from './../../components/ProfileIcons';
import {useSelector} from 'react-redux';
import {MediakitSection, MediakitSectionItem, selectMediakitUser, updateSectionItem} from './../../features/stores/mediakitUser.slice';
import useRequest, {useUploadRequest} from './../../API/request';
import {store} from './../../app/store';
import {setDataChange, setShouldSave} from './../../features/stores/changeData.slice';
import {refreshMe} from './../../API/login';
import {toast} from 'react-toastify';
import RouteLeavingGuard from './../../components/UnsavedChanges/RouteLeavingGuard';
import WarningDialog from './../../components/UnsavedChanges/WarningDialog';
import {TailSpin} from 'react-loader-spinner';
import PreviewSite from './../../components/PreviewSite';
import {useDidUpdateEffect} from '../../hooks/useDidUpdateEffect';
import {mediakitUserExist, extendUrl} from '../../Helper/generalHelper';
import {dataURLtoFile} from '../../Helper/imageCropper';
import FeaturedVideo from './../../components/FeaturedVideo/FeaturedVideo';

const tabData = ['profile', 'icons', 'past_campaigns'];

const selectChangeData = (state: any) => state.changeData.changeData;
const selectShouldSave = (state: any) => state.changeData.shouldSaveEverything;

const MyProfile = () => {
    const {t} = useTranslation();
    const dataChange = useSelector(selectChangeData);
    const shouldSave = useSelector(selectShouldSave);
    const mediakitUser = useSelector(selectMediakitUser) as any;
    const userExist = mediakitUserExist();
    const finalTabData = tabData;
    const [activeTab, setActiveTab] = useState(finalTabData[0]);
    const [validationFinish, setValidationFinish] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [modalText, setModalText] = useState('');
    const [modalButtonText, setModalButtonText] = useState('');
    const updateProfileRequest = useRequest({method: 'PUT', url: '/user'});
    const uploadLinksRequest = useRequest({method: 'POST', url: '/socials'});
    const uploadFeaturedVideoRequest = useRequest({method: 'PUT', url: '/featured/video'});
    const uploadAvatarRequest = useUploadRequest({method: 'POST', url: '/user/avatar'});
    const getProfileContent = () => {
        switch (activeTab) {
            case 'profile':
                return <UserProfile />;
            case 'icons':
                return <ProfileIcons />;
            case 'past_campaigns':
                return <FeaturedVideo/>;
            default:
                return null;
        }
    };

    const saveEverything = async () => {
        let avatarUrl = '';
        if (mediakitUser.avatarUrl?.includes('base64')) {
            const file = dataURLtoFile(mediakitUser.avatarUrl, `avatar-${mediakitUser.id}`);
            const params = {
              file: {
                key: 'file',
                value: file,
                fileName: mediakitUser.id,
              },
            };
      
            avatarUrl = await uploadAvatarRequest.doRequest(params);
        }
        const payload: any = {bio: mediakitUser.bio, fullname: mediakitUser.fullname, country: mediakitUser.country, displayFollower: mediakitUser.displayFollower};
        if (avatarUrl?.length) {
            payload.avatarUrl = avatarUrl;
        }
        await updateProfileRequest.doRequest(payload);
        const mediakitSocialData = mediakitUser.mediakitSection.filter((e: any) => e.type === 'social').map((section: MediakitSection) => section.mediakitSectionLinks).reduce((acc: any, curr: any) => {
            acc = [...acc, ...curr];
            return acc;
            });
        const socialPayload: any = [];
        mediakitSocialData.map((e: any) => {
            const data = JSON.parse(JSON.stringify(e));
            if (!/[^a-zA-Z0-9]/.test(data?.id)) {
                delete data.id;
            }
            socialPayload.push(data);
        });
        await uploadLinksRequest.doRequest({items: socialPayload});
        const mediakitFeaturedVideoData = mediakitUser?.mediakitSection?.filter((e: any) => e.type === 'video')?.map((section: MediakitSection) => section.mediakitSectionLinks)?.reduce((acc: any, curr: any) => {
            acc = [...acc, ...curr];
            return acc;
            });
        const featureVideoPayload: any = [];
        mediakitFeaturedVideoData.map((e: any) => {
            const data = JSON.parse(JSON.stringify(e));
            if (!/[^a-zA-Z0-9]/.test(data?.id)) {
                delete data.id;
            }
            featureVideoPayload.push(data);
        });
        await uploadFeaturedVideoRequest.doRequest({items: featureVideoPayload});
        store.dispatch(setShouldSave(false));
        store.dispatch(setDataChange(false));
        setValidationFinish(false);
        toast(<span style={{color: 'black'}}>{t(!!!userExist ? 'account_created' : 'changes_saved')}</span>);
        refreshMe();
    };

    const validateAllBeforeSave = () => {
        setValidationFinish(false);
        let error = false;
        const socialSection = mediakitUser?.mediakitSection.find((e: MediakitSection) => e.type === 'social');
        socialSection?.mediakitSectionLinks.map((el: MediakitSectionItem) => {
          if (!el.url) {
            setShowModal(true);
            setModalText(t('icon_link_empty_error'));
            setModalButtonText(t('add_link_btn_text'));
            error = true;
            return;
          }
          const linkType = el.platform;
          // add prefix if only username/id is present
          const newLink = extendUrl({type: linkType, url: el.url});
          store.dispatch(updateSectionItem({id: el.id, data: {url: newLink}}));
        });
        if (error) {
          // error has occured, need to stop the saving flow
          setValidationFinish(false);
          store.dispatch(setShouldSave(false));
          return false;
        }
        setValidationFinish(true);
        return true;
      };

    useEffect(() => {
        if (updateProfileRequest.hasError || uploadFeaturedVideoRequest.hasError) {
          toast.warning(<span style={{color: 'black'}}>{t('something_went_wrong')}</span>);
        }
      }, [updateProfileRequest.hasError, uploadFeaturedVideoRequest.hasError]);

    useDidUpdateEffect(async () => {
        if (shouldSave) {
            validateAllBeforeSave();
          }
          if (shouldSave && validationFinish && dataChange) {
            saveEverything();
          }
    }, [shouldSave, validationFinish]);
    useEffect(() => {
        if (!!!userExist) {
            // store.dispatch(setDataChange(true));
            saveEverything();
        }
    }, [userExist]);
    return (
        <div className={classNames(styles.profile_container)}>
            <RouteLeavingGuard when={dataChange} userNotExist={!!!userExist} navigate={() => '/mediakit/profile/my-profile'}
                shouldBlockNavigation={() => true} saveFunction={async ()=>{
                const validationResult = await validateAllBeforeSave();
                if (validationResult) {
                    await saveEverything();
                    return true;
                }
                return false;
            }}/>
            <WarningDialog setIsOpen={setShowModal} open={showModal} contentHeadline={modalText} buttonText={modalButtonText}/>
            {(shouldSave || uploadAvatarRequest.isFetching || updateProfileRequest.isFetching || uploadLinksRequest.isFetching) ? <div className={styles.loadingOnSave}><TailSpin color="#EB3B5A" height={80} width={80} /></div> : ''}
            <div className={styles.profile_left}>
                <div className={styles.left_container}>
                    <div className={styles.tab_pill_container}>
                        {finalTabData.map((tab) => (
                            <div key={tab} className={`${styles.tab_item} ${activeTab === tab ? styles.tab_active : ''}`} onClick={() => setActiveTab(tab)}>{t(tab)}</div>
                        ))}
                    </div>
                    <div className={styles.profile_body}>
                        {getProfileContent()}
                    </div>
                </div>
            </div>
            <div className={styles.profile_right}>
                <PreviewSite />
            </div>
        </div>
    );
};

export default MyProfile;
